import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Images } from "./assets/asset";
import { Howl } from 'howler';

const sound = new Howl({
  src: [Images.keyboardeffect],
  volume: 1.0,
  loop: true
});

ReactDOM.render(
  <React.StrictMode>
    <App typeWriterSound={sound} />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
